import { useSyncExternalStore } from "react";

// `storage` only fires in OTHER tabs, so writes made by this tab are broadcast
// through a custom event to keep subscribers in sync.
const LOCAL_STORAGE_UPDATE_EVENT = "local-storage-update";

const createLocalStorageSubscribe = (key: string) => (callback: () => void) => {
  const handler = (e: StorageEvent) => {
    if (e.key === key) callback();
  };

  window.addEventListener("storage", handler);
  window.addEventListener(LOCAL_STORAGE_UPDATE_EVENT, callback);
  return () => {
    window.removeEventListener("storage", handler);
    window.removeEventListener(LOCAL_STORAGE_UPDATE_EVENT, callback);
  };
};

const createLocalStorageSnapshot = (key: string) => () => {
  return localStorage.getItem(key);
};

export const useLocalStorage = (key: string) => {
  return useSyncExternalStore(
    createLocalStorageSubscribe(key),
    createLocalStorageSnapshot(key)
  );
};

// Use instead of `localStorage.setItem` whenever a `useLocalStorage` subscriber
// has to react to the write within the same tab.
export const writeLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
  window.dispatchEvent(new Event(LOCAL_STORAGE_UPDATE_EVENT));
};
